'use client';

import 'react';
import getElementClientRectByPosition from '../helpers/getElementClientRectByPosition.js';

function getPosition(options) {
    var placement = options.placement, position = options.position, reference = options.reference, popup = options.popup, popupConfigs = options.popupConfigs, shiftValues = options.shiftValues;
    var _a = (popupConfigs || {}).offset, offset = _a === void 0 ? 0 : _a;
    var referenceRect = getElementClientRectByPosition(reference, position);
    var popupRect = getElementClientRectByPosition(popup, position);
    var xPos = referenceRect.x;
    var yPos = referenceRect.y;
    var referenceHeight = referenceRect.height;
    var referenceWidth = referenceRect.width;
    var popupHeight = popupRect.height;
    var popupWidth = popupRect.width;
    var returnPosition = {
        x: 0,
        y: 0
    };
    /*
     * Calculate y position
     * */
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            returnPosition.y = yPos - (popupHeight + offset);
            break;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            returnPosition.y = yPos + referenceHeight + offset;
            break;
        case 'left-start':
        case 'right-start':
            returnPosition.y = yPos;
            break;
        case 'left':
        case 'right':
            returnPosition.y = yPos + referenceHeight / 2 - popupHeight / 2;
            break;
        case 'left-end':
        case 'right-end':
            returnPosition.y = yPos + referenceHeight - popupHeight;
            break;
    }
    /*
     * Calculate x position
     * */
    switch (placement) {
        case 'left-start':
        case 'left':
        case 'left-end':
            returnPosition.x = xPos - (popupWidth + offset);
            break;
        case 'right-start':
        case 'right':
        case 'right-end':
            returnPosition.x = xPos + referenceWidth + offset;
            break;
        case 'top-start':
        case 'bottom-start':
            returnPosition.x = xPos;
            break;
        case 'top':
        case 'bottom':
            returnPosition.x = xPos + referenceWidth / 2 - popupWidth / 2;
            break;
        case 'top-end':
        case 'bottom-end':
            returnPosition.x = xPos + referenceWidth - popupRect.width;
            break;
    }
    /*
     * Add shift values
     * */
    returnPosition.x -= shiftValues.x;
    returnPosition.y -= shiftValues.y;
    return returnPosition;
}

export { getPosition as default };
//# sourceMappingURL=getPosition.js.map
